import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import './MensWear.css'

function MensWear() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch('http://localhost:3001/api/products/men');
        if (!response.ok) throw new Error('Failed to fetch products');
        const data = await response.json();
        setProducts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const getStockStatus = (quantity) => {
    if (quantity > 10) return 'In Stock';
    if (quantity > 0) return `Only ${quantity} left`;
    return 'Out of Stock';
  };

  const getStockClass = (quantity) => {
    if (quantity > 10) return 'in-stock';
    if (quantity > 0) return 'low-stock';
    return 'out-of-stock';
  };

  if (loading) return <div className="loading-container">Loading...</div>;
  if (error) return <div className="error-message">Error: {error}</div>;
  if (products.length === 0) return <div className="no-products">No products found</div>;

  return (
    <div className="products-container">
      <h2 className="section-title">Men's Collection</h2>
      <h5 className="section-count">{products.length}</h5>
      <div className="products-grid">
        {products.map(product => (
          <div key={product._id} className="product-card" onClick={() => navigate(`/product/${product._id}`)}>
            <div className="product-image-container">
              {product.images?.[0] ? (
                <img
                  src={`http://localhost:3001/uploads/${product.images[0]}`}
                  alt={product.description}
                  className="product-image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'path-to-fallback-image.jpg';
                  }}
                />
              ) : (
                <div className="image-placeholder">No Image Available</div>
              )}
              {product.price.discount > 0 && (
                <div className="discount-badge">{product.price.discount}% OFF</div>
              )}
              <div className={`stock-status ${getStockClass(product.quantity)}`}>
                {getStockStatus(product.quantity)}
              </div>
            </div>
            <div className="product-details">
              <h3 className="product-brand">{product.brand}</h3>
              <p className="product-type">{product.productType}</p>
              <div className="price-container">
                <span className="current-price">₹{product.price.discounted || product.price.actual}</span>
                {product.price.discounted && (
                  <span className="original-price">₹{product.price.actual}</span>
                )}
              </div>
              <div className="product-meta">
                <span>Color: {product.color}</span>
                <span>Size: {product.size}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MensWear